import script from "./ManagementInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagementInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ManagementInfo.vue?vue&type=style&index=0&id=33073e29&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33073e29"]])

export default __exports__